import { FormattedMessage } from 'components/shared/Intl';
import type { CreditUnderlying } from 'models/underlying/credit';
import { FC } from 'react';

export const Credit: FC<CreditUnderlying> = ({ isin, rating, seniorityType, transactionType }) => (
  <>
    {isin && (
      <>
        <dt>ISIN:</dt>
        <dd>{isin}</dd>
      </>
    )}

    {transactionType && (
      <>
        <dt>TRANSACTION TYPE:</dt>
        <dd>{transactionType}</dd>
      </>
    )}

    {seniorityType && (
      <>
        <dt>SENIORITY:</dt>
        <dd>
          <FormattedMessage id={`quote.underlyingsGrid.seniorityTypes.${seniorityType}` as any} />
        </dd>
      </>
    )}

    {rating && (
      <>
        <dt>RATING:</dt>
        <dd>{rating || 'Not Available'}</dd>
      </>
    )}
  </>
);
